import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BurgerMenuButtonComponent } from '@app/components/burgerMenuButton/burgerMenuButton.component';

@NgModule({
  imports: [CommonModule],
  declarations: [BurgerMenuButtonComponent],
  exports: [BurgerMenuButtonComponent],
})
export class BurgerMenuButtonModule {}
